import React, { useState, useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { isBrowser } from "react-device-detect";
import { useSelector, useDispatch } from "react-redux";
import Axios from "axios";
import { Row, Col, Image } from "react-bootstrap";

//STYLES
import * as UserRouteSystemStyles from "./styles/userRouteSystem";

//ACTIONS
import * as UserActions from "../../store/actions/user";
import * as GS_generalSettings from "../../store/actions/globalSettings/GS_generalSettings";

import EnvironmentPodsMap from "../pods/environmentPodsMap";

//IMAGES
// import StGilesPic from "../../public/images/stGiles.jpeg";

//USER SIDE
import BrowserNavBar from "../pods/special/navBar/browserNavBar";
// import MobileNavBar from "../pods/special/navBar/mobileNavBar";

//COMPONENTS
import Home from "./home";

//STYLE COMPONENTS

//FROM ADMIN CORE SIDE
import AdminBanner from "../../administration/pods/adminBanner/adminBanner";
import PageViewer from "../../administration/pods/pageViewer/pageViewer";
import PodViewer from "../../administration/pods/wholeSite/podViewer";
import FrontEndMainContact from "../../administration/pods/contacts/files/frontEndMainContact";
import SiteOffline from "../../administration/pods/siteOffline/files/siteOffline";

import MembershipExtra from "../pods/membershipExtra/mainFiles/frontEnd/podRouter";
import WebsiterViewer from "../pods/stylingPortal/frontEnd/files/websiteViewer";

function UserRouteSystem() {
    const user = useSelector((state) => state.user);

    const [isLoaded, setIsLoaded] = useState(false);
    const [isOffline, setIsOffline] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        onOpen();
    }, []);

    function onOpen() {
        Axios.post("/pods/userRouter/getOpeningData")
            .then((res) => {
                const data = res.data;
                console.log(data);
                dispatch(GS_generalSettings.UpdateMainContactPageVisible(data.settings.mainContactPage.value == "true"));
                dispatch(GS_generalSettings.UpdateSiteOffline(data.settings.siteOffline.value == "true"));
                dispatch(GS_generalSettings.UpdateSiteOfflineMessage(data.settings.siteOffline.subValue));
                setIsOffline(data.settings.siteOffline.value == "true");

                if (user.auth && user.type !== "registered") {
                    dispatch(UserActions.UpdateAdminSignedIn(true));
                }

                //MEMBERSHIP EXTRA POD
                if (user.requestedPassword) {
                    navigate("/membership/changePassword");
                }
                if (!user.auth) {
                    navigate("/membership/login");
                } else {
                    if (user.type != "seniorAdmin") {
                        const styleData = { userID: user.id };
                        Axios.post("/pods/stylingPortalAdmin/getStyleData", styleData)
                            .then((res) => {
                                const data = res.data;
                                if (data.error == "null") {
                                    navigate(`/style/${data.tag}`);
                                }
                            })
                            .catch((err) => console.log(err));
                    }
                }

                setIsLoaded(true);
            })
            .catch((err) => console.log(err));
    }

    function offlineUserCheck(role) {
        if (role == "modifier" || role == "registered" || role == "") {
            return false;
        } else {
            return true;
        }
    }

    return (
        <div>
            {isLoaded && (
                <div>
                    {isOffline && !offlineUserCheck(user.type) ? (
                        <div>
                            <SiteOffline />
                        </div>
                    ) : (
                        <div>
                            {/* <div style={UserRouteSystemStyles.slideShowContainer}>
                                {" "} */}
                            {/* <NavBar /> */}
                            {/* <SlideShow /> */}
                            {/* <SimpleSectionCenteredText /> */}
                            {/* <div style={{ backgroundColor: "yellow", height: "200vh" }}></div> */}
                            {/* </div> */}
                            {/* {isBrowser ? <BrowserNavBar /> : <MobileNavBar />} */}
                            {/* <Row>
                                <Col>
                                    <BrowserNavBar />
                                </Col>
                            </Row> */}
                            {/* <Row>
                                <Col>
                                    <Image src={StGilesPic} style={UserRouteSystemStyles.mainImage} />
                                </Col>
                            </Row>
                            <Home /> */}
                            <Row>
                                <Col>
                                    <Row>
                                        <Col style={UserRouteSystemStyles.mainBody}>
                                            <Routes>
                                                <Route path="/membership/*" element={<MembershipExtra />} />
                                                <Route path="/style/:tag/*" element={<WebsiterViewer />} />
                                            </Routes>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default UserRouteSystem;
